import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=6e42a2ae&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e42a2ae')) {
      api.createRecord('6e42a2ae', component.options)
    } else {
      api.reload('6e42a2ae', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=6e42a2ae&", function () {
      api.rerender('6e42a2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/dashboard/views/Dashboard.vue"
export default component.exports